import React from "react";
import Films from "../../components/Films/Films";

const TopRated = () => {
  return <Films type="top_rated" />;
};

export default TopRated;
